/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const DegreeIcon = /*#__PURE__*/ createSvgIcon(
  'DegreeIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.792 13.917c.139.25.326.43.562.541L8.417 16.5c.11.056.222.094.333.115a1.831 1.831 0 00.671 0c.108-.021.218-.06.329-.115l4.063-2.042c.25-.125.44-.309.572-.552.132-.243.198-.503.198-.781V9.083l2-1v5c0 .195.073.368.22.521.145.153.319.23.52.23a.73.73 0 00.531-.23.718.718 0 00.23-.52V7.77a.701.701 0 00-.105-.37.772.772 0 00-.291-.276L9.75 3.167A1.444 1.444 0 009.083 3a1.405 1.405 0 00-.666.167l-7 3.5a.734.734 0 00-.313.278.743.743 0 00-.104.388c0 .143.035.272.104.388.07.117.174.21.313.279l2.166 1.083v4.042c0 .278.07.542.209.792zm9.683-5.959l-4.392 2.188-5.646-2.813 5.646-2.812 4.392 2.187H9.02a.625.625 0 000 1.25h4.454zm-.392 5.188l-4 1.979-4-1.98v-3.29l3.271 1.624c.111.07.226.118.344.146a1.68 1.68 0 00.746 0c.12-.028.243-.076.368-.146l3.271-1.625v3.292z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default DegreeIcon;
